import { render, staticRenderFns } from "./MediaImageGagnantPromo.vue?vue&type=template&id=18996af2&scoped=true"
import script from "./MediaImageGagnantPromo.vue?vue&type=script&lang=js"
export * from "./MediaImageGagnantPromo.vue?vue&type=script&lang=js"
import style0 from "./MediaImageGagnantPromo.vue?vue&type=style&index=0&id=18996af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18996af2",
  null
  
)

export default component.exports